export const links = {
  MY_ASSURANT_POLICY: "https://MyAssurantPolicy.com",
  CUSTOMER_ACCOUNT_LOGIN: "https://www.nssi.com/customer/account/login/",
};
